module.exports = __webpack_public_path__ + "static/media/exclusive_without_num-4.b6733f0e.png";